import { gql } from '@apollo/client'

export const BASE_QUESTION_FIELDS = gql`
  fragment BaseQuestionFields on QuestionType {
    id
    createdAt
    deletedAt
    title
    templateName
    questionAsHtml
    questionStem
    answerExplanationAsHtml
    testletScenario
    alreadyInUse
    answer {
      id
      isCorrect
      point
      textAsHtml
      order
    }
    type
    isTemplate
    questionCategory {
      id
      title
    }
    subjects {
      id
      tabName
      slug
      platform {
        id
        title
        category
        shortDescription
        description
        isActive
        slug
      }
    }
    invertQuestionImages
    invertAnswerImages
    invertAnswerExplanationImages
    sourcesAndCredits
    # INBDE fields:
    exhibit
    xRay
    photo
    patient
    # Additional NBDHE fields:
    dentalChart
    periodontalChart
    panoramicChart
    chiefComplaint
    backgroundAndOrPatientHistory
    currentFinding
    # Additional NDEB fields:
    additionalInformation
    dentalHistory
    medicalHistory
    model3D
    # Additional NDEB table fields:
    endodonticTable
    orthodonticTable
    periodontalTable
    showMultipleSelectionLabel
  }
`

export const GET_LIST_QUESTION = gql`
  ${BASE_QUESTION_FIELDS}
  query findAllQuestion($params: QuestionQueryInput! = {}) {
    findAllQuestion(query: $params) {
      count
      items {
        ...BaseQuestionFields
      }
    }
  }
`

export const GET_LIST_DELETED_QUESTION = gql`
  ${BASE_QUESTION_FIELDS}
  query findAllDeletedQuestion($params: QuestionQueryInput! = {}) {
    findAllDeletedQuestion(query: $params) {
      count
      items {
        ...BaseQuestionFields
      }
    }
  }
`

export const GET_ONE_QUESTION = gql`
  ${BASE_QUESTION_FIELDS}
  query findOneQuestion($params: String!) {
    findOneQuestion(id: $params) {
      ...BaseQuestionFields
      history {
        updatedBy
        updatedAt
      }
    }
  }
`

export const UPDATE_QUESTION = gql`
  mutation updateQuestion($params: UpdateQuestionInput!) {
    updateQuestion(updateQuestionInputFieldName: $params) {
      id
      createdAt
      title
      type
      isTemplate
      questionAsHtml
      answerExplanationAsHtml
    }
  }
`

export const CREATE_QUESTION = gql`
  mutation createQuestion($params: CreateQuestionInput!) {
    createQuestion(createQuestionInput: $params) {
      id
      createdAt
      title
      type
      isTemplate
      questionAsHtml
      answerExplanationAsHtml
    }
  }
`

export const REMOVE_QUESTION = gql`
  mutation removeQuestion($id: String!) {
    removeQuestion(id: $id) {
      affected
      raw
    }
  }
`

export const SEARCH_TEMPLATE_QUESTION = gql`
  query searchTemplateQuestion(
    $searchString: String
    $questionType: QuestionTypeEnum
    $skip: Int
    $take: Int
    $questionCategoryId: String
  ) {
    searchTemplateQuestion(
      searchString: $searchString
      questionType: $questionType
      skip: $skip
      take: $take
      questionCategoryId: $questionCategoryId
    ) {
      count
      items {
        id
        title
        createdAt
        templateName
        isTemplate
      }
    }
  }
`

export const GET_QUESTION_LOCATION = gql`
  query findQuestionLocation($id: String!) {
    findQuestionLocation(id: $id) {
      questionId
      questionName
      location {
        locationId
        locationName
        platformName
      }
    }
  }
`

export const BULK_SOFT_REMOVE_QUESTION = gql`
  mutation bulkSoftRemoveQuestion($ids: [LinkQuestionInput!]!) {
    bulkSoftRemoveQuestion(ids: $ids) {
      affected
      raw
    }
  }
`

export const BULK_RESTORE_QUESTION = gql`
  mutation bulkRestoreQuestion($ids: [LinkQuestionInput!]!) {
    bulkRestoreQuestion(linkQuestionInput: $ids) {
      affected
      raw
    }
  }
`

export const BULK_REMOVE_QUESTION = gql`
  mutation bulkRemoveQuestion($ids: [LinkQuestionInput!]!) {
    bulkRemoveQuestion(ids: $ids) {
      affected
      raw
    }
  }
`
